/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catch_Boundary_Back_To_HomeInputs */

const en_catch_boundary_back_to_home = /** @type {(inputs: Catch_Boundary_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Home`)
};

const es_catch_boundary_back_to_home = /** @type {(inputs: Catch_Boundary_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al inicio`)
};

/**
* | output |
* | --- |
* | "Back to Home" |
*
* @param {Catch_Boundary_Back_To_HomeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const catch_boundary_back_to_home = /** @type {((inputs?: Catch_Boundary_Back_To_HomeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catch_Boundary_Back_To_HomeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_catch_boundary_back_to_home(inputs)
	return es_catch_boundary_back_to_home(inputs)
});